import { getFormData } from 'app/utils/formUtils'
import { fileValidation } from 'app/utils/validationUtils'
import { SponsorRequest } from 'EstraSponsor'
import * as Yup from 'yup'

export type SponsorRequestFilesFormData = {
  sponsor_request_file?: FileList | null
  presentation_file?: FileList | null
}
export const sponsorRequestFilesDefaultValues: SponsorRequestFilesFormData = {
  sponsor_request_file: null,
  presentation_file: null,
}

export const sponsorRequestFilesValidationSchema = Yup.object().shape({
  sponsor_request_file: fileValidation({
    isRequired: true,
  }),
  presentation_file: fileValidation({
    isRequired: false,
  }),
})

export const adaptApiToFormData = (
  sponsorRequest: SponsorRequest
): SponsorRequestFilesFormData =>
  // If sponsor request already has a file, form field has to be set to undefined,
  // to avoid required validation
  ({
    sponsor_request_file: sponsorRequest.sponsor_request_pdf_url
      ? undefined
      : sponsorRequestFilesDefaultValues['sponsor_request_file'],
    presentation_file: sponsorRequest.presentation_url
      ? undefined
      : sponsorRequestFilesDefaultValues['presentation_file'],
  })

export const adaptFormDataToApi = (
  formData: SponsorRequestFilesFormData
): FormData => getFormData({ formData: formData })
